import { Route, Routes, Navigate } from "react-router-dom";
import { MasterLayout } from "src/_metronic/layout/MasterLayout";
import AllCalendar from "../pages/allCalendar/AllCalendar";
import Offers from "../pages/offers/Offers";
import Strategies from "../pages/strategies/Strategies";
import Dashboard from "../pages/dashboard/Dashboard";
import SpecificCalendar from "../pages/allCalendar/SpecificCalendar";
import SMSList from "../pages/lists/smsList/SMSList";
import EmailList from "../pages/lists/emailList/EmailList";
import SMSAnalytics from "../pages/lists/smsAnalytics/SMSAnalytics";
import TagManagement from "../pages/lists/tagManagement/TagManagement";
import OfferProblems from "../pages/offers/OfferProblems";
import Details from "../pages/offers/Details";
import EmailCreative from "../pages/creatives/EmailCreative";
import SmsCreative from "../pages/creatives/SmsCreative";
import Settings from "../pages/settings/Settings";

const PrivateRoutes = () => {
  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path="auth/*" element={<Navigate to={"/dashboard"} />} />
        {/* Pages */}
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="allCalendar" element={<AllCalendar />} />
        <Route path="specificCalendar" element={<SpecificCalendar />} />
        <Route path="offers" element={<Offers />} />
        <Route path="strategies" element={<Strategies />} />
        <Route path="lists/SMS" element={<SMSList />} />
        <Route path="lists/SMSAnalytics" element={<SMSAnalytics />} />
        <Route path="lists/Email" element={<EmailList />} />
        <Route path="lists/TagManagement" element={<TagManagement />} />
        <Route path="creatives/sms" element={<SmsCreative />} />
        <Route path="creatives/email" element={<EmailCreative />} />
        <Route path="offers/offerProblems" element={<OfferProblems />} />
        <Route path="offers/details" element={<Details />} />
        <Route path="settings" element={<Settings />} />
        {/* Page Not Found */}
        <Route path="*" element={<Navigate to="/error/404" />} />
      </Route>
    </Routes>
  );
};

export { PrivateRoutes };
